import { API_ROOT_URL } from "../config";

export const AppVersionService = {
  fetchAppVersion,
};

function fetchAppVersion() {
  
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
    
      }
    };
    return fetch(`${API_ROOT_URL}/projects/app-version/`, requestOptions).then(response =>
      response.json()
    );
  }


// WEBPACK FOOTER //
// ./src/services/appVersion.service.js